/* eslint-disable */
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { menuLateralWidth } from "@utils/const";
import { Button } from "semantic-ui-react";
import m from "@utils/strings";
import "@styles/consulta-pronto-socorro.css";

const styles = {
  divContainer: {
    position: "absolute",
    right: 0,
    height: "100%",
    width: menuLateralWidth,
    backgroundColor: "#f5f5f6",
    marginTop: -100,
    padding: 25,
    zIndex: 0,
  },
  divContainerExterno: {},
  nomeUsuario: {
    height: 24,
    color: "#333333",
    fontFamily: "Work Sans",
    fontSize: 17,
    fontWeight: 400,
  },
  circle: {
    width: 6,
    height: 6,
    backgroundColor: "#7bc72a",
    borderRadius: "50%",
    marginBottom: 0,
  },
  statusUsuario: {
    height: "14",
    color: "#7bc72a",
    fontFamily: "Work Sans",
    fontSize: 12,
    fontWeight: 400,
    marginLeft: 5,
  },
  dispensadoBiometria: {
    fontSize: 16,
    color: "#fae64b",
    fontFamily: "Work Sans",
    fontWeight: 500,
    marginTop:10,
  },
  dataVerificacao: {
    color: "#9b9b9b",
    fontFamily: "Work Sans",
    fontSize: 12,
    fontWeight: 400,
  },
  numeroCarteira: {
    height: 16,
    color: "#333333",
    fontFamily: "Work Sans",
    fontSize: 14,
    fontWeight: 400,
  },
  numeroCartao: {
    height: 20,
    color: "#333333",
    fontFamily: "Source Code Pro",
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: 2,
  },
  dadosSolicitante: {
    height: 16,
    color: "#333333",
    fontFamily: "Work Sans",
    fontSize: 16,
    fontWeight: 400,
  },
  dadosSolicitanteDescricao: {
    height: 16,
    color: "#9b9b9b",
    fontFamily: "Work Sans",
    fontSize: 14,
    fontWeight: 400,
  },
  procedimentoOutroSolicitanteRectangle: {
    width: 312,
    height: 148,
    paddingLeft: 30,
    paddingRight: 30,
    borderRadius: 6,
    border: "1px solid #fbb12f",
    backgroundColor: "white",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.8,
    shadowRadius: 2,
    elevation: 1,
    textAlign: "center",
    display: "table-cell",
    verticalAlign: "middle",
    color: "#333333",
    fontFamily: "Work Sans",
    fontSize: 16,
    fontWeight: 400,
  },
};

class MenuLateralUsuario extends Component {
  formataHorarioAtual() {
    var tempDate = new Date();
    let day = tempDate.getDate().toString();
    let month = (tempDate.getMonth() + 1).toString();
    let hours = tempDate.getHours().toString();
    let minutes = tempDate.getMinutes().toString();

    day = day.length == 1 ? "0" + day : day;
    month = month.length == 1 ? "0" + month : month;
    hours = hours.length == 1 ? "0" + hours : hours;
    minutes = minutes.length == 1 ? "0" + minutes : minutes;

    var date =
      day +
      "/" +
      month +
      "/" +
      tempDate.getFullYear() +
      " " +
      hours +
      ":" +
      minutes;
    const currDate = date;
    return currDate;
  }

  formataHorarioAtendimento(dataAtendimento) {
    if (new Date(dataAtendimento).toString() !== "Invalid Date") {
      let date = new Date(dataAtendimento);

      let day = date.getDate().toString();
      let month = (date.getMonth() + 1).toString();

      day = day.length == 1 ? "0" + day : day;
      month = month.length == 1 ? "0" + month : month;

      let newDate = day + "/" + month + "/" + date.getFullYear();
      const currDate = newDate;
      return currDate;
    } else {
      return "";
    }
  }

  render() {
    if (
      !this.props.beneficiario?.data?.Elegibilidade ||
      this.props.beneficiario.data.Elegibilidade?.IndicadorElegibilidade === "N"
    ) {
      return (
        <div className={this.props.classes.divContainer}>
          <div className={this.props.classes.divContainerExterno}></div>
        </div>
      );
    } else {
      const { classes, beneficiario, exame } = this.props;
      const exameAutorizado =
        exame && exame.data && exame.data.SolicitacaoProcedimento.Senha
          ? true
          : false;
      const profissionalExecutante = exameAutorizado
        ? exame.data.SolicitacaoProcedimento.ProfissionalExecutanteDTO
            .ProfissionalExecutante
        : null;

      const {
        data: { Elegibilidade, SolicitacaoProcedimento, Biometria },
      } = beneficiario;
      const horario_verificacao = this.formataHorarioAtual();
      const horario_atendimento = this.formataHorarioAtendimento(
        beneficiario.data.Elegibilidade.DataAtendimento
      );
      return (
        <div className={classes.divContainer}>
          <div className={classes.divContainerExterno}>
            <MenuLateralField>
              <label className={classes.nomeUsuario}>
                {Elegibilidade.NomeBeneficiario}
              </label>
            </MenuLateralField>
            <MenuLateralField style={{ marginTop: -5 }}>
              <label className={classes.circle}></label>
              <label className={classes.statusUsuario}>
                {m.MENU_LATERAL.BENEFICIARIO_ATIVO_EM + horario_atendimento}
              </label>
            </MenuLateralField>
            <MenuLateralField style={{ marginTop: -5 }}>
              <label className={classes.dataVerificacao}>
                {SolicitacaoProcedimento &&
                SolicitacaoProcedimento.Beneficiario &&
                SolicitacaoProcedimento.Beneficiario.IdentificadorRecemNato
                  ? m.MENU_LATERAL.LABEL_RECEM_NASCIDO
                  : ""}
              </label>
            </MenuLateralField>
            <MenuLateralField style={{ marginTop: -5 }}>
              <label className={classes.dataVerificacao}>
                {m.MENU_LATERAL.VERIFICADO_EM + horario_verificacao}
              </label>
            </MenuLateralField>
            {Biometria?.Dispensado ? (
              <MenuLateralField>
                <label className={classes.dispensadoBiometria}>
                  {m.MENU_LATERAL.BENEFICIARIO_ISENTO_BIOMETRIA}
                </label>
              </MenuLateralField>
            ) : null}
            <MenuLateralField style={{ marginTop: 15 }}>
              <label className={classes.numeroCarteira}>
                {m.MENU_LATERAL.LABEL_NUMERO_CARTEIRA_SAUDE}
              </label>
            </MenuLateralField>
            <MenuLateralField>
              <label className={classes.numeroCarteira}>
                <label className={classes.numeroCartao}>
                  {Elegibilidade.NumeroCarteiraBeneficiario}
                </label>
              </label>
            </MenuLateralField>
            {/* <div className={"divContainerInterno"} style={{ display: "inherit", marginTop: 15 }}>
                            <div className={"divExterior"}>
                                <div className={"divInterior"}>
                                    <label className={classes.numeroCarteira}>{m.MENU_LATERAL.LABEL_CARTAO_NACIONAL_SAUDE}</label>
                                </div>
                            </div>
                        </div>
                        <div className={"divContainerInterno"} style={{ display: "inherit" }}>
                            <div className={"divExterior"}>
                                <div className={"divInterior"}>
                                    <label className={classes.numeroCartao}>
                                        {Elegibilidade.CartaoNacionalSaude ? Elegibilidade.CartaoNacionalSaude : "Cartão não informado"}
                                    </label>
                                </div>
                            </div>
                        </div> */}
          </div>
          <div
            className={classes.divContainerExterno}
            style={exameAutorizado ? { display: "block" } : { display: "none" }}
          >
            <div
              className={"divContainerInterno"}
              style={{ display: "inherit", marginTop: 40, marginBottom: 5 }}
            >
              <div className={"divExterior"} style={{ marginTop: 5 }}>
                <div className={"divInterior"}>
                  <label className={classes.dadosSolicitante}>
                    {m.MENU_LATERAL.LABEL_DADOS_PROFISSIONAL_SOLICITANTE}
                  </label>
                </div>
              </div>
              <div className={"divExterior"} style={{ marginTop: 5 }}>
                <div className={"divInterior"}>
                  <label className={classes.dadosSolicitanteDescricao}>
                    {exameAutorizado ? `${profissionalExecutante.Nome}` : ""}
                  </label>
                </div>
              </div>
              <div className={"divExterior"} style={{ marginTop: 5 }}>
                <div className={"divInterior"}>
                  <label className={classes.dadosSolicitanteDescricao}>
                    {exameAutorizado
                      ? `${profissionalExecutante.Conselho}-${profissionalExecutante.Estado} ${profissionalExecutante.Numeroconselho}`
                      : ""}
                  </label>
                </div>
              </div>
              <div className={"divExterior"} style={{ marginTop: 5 }}>
                <div className={"divInterior"}>
                  <label className={classes.dadosSolicitanteDescricao}>
                    {
                      "" /* `Data do atendimento: ${exameAutorizado? 'teste': 'testeN'}` */
                    }
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

const MenuLateralField = (props) => {
  return (
    <div
      className={"divContainerInterno"}
      style={{ display: "inherit", ...props.style }}
    >
      <div className={"divExterior"}>
        <div className={"divInterior"}>{props.children}</div>
      </div>
    </div>
  );
};

export default withStyles(styles)(MenuLateralUsuario);
